import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiAdobeaftereffects,
  SiAdobeillustrator,
  SiAdobephotoshop,
  SiAdobepremierepro,
  SiBlender,
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiAdobeaftereffects className="text-white" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiAdobeillustrator className="text-white" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiAdobephotoshop className="text-white" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiAdobepremierepro className="text-white" />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiBlender className="text-white" />
      </Col>
    </Row>
  );
}

export default Toolstack;
